import { GetCardPaymentsQuery } from "@/api/hasura/generated/graphql"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { useQuery } from "@/api/utils/useQuery"
import { CardPaymentDetailsParser } from "@/models/cardPaymentDetails/cardPaymentDetails.parser"
import { ICardPaymentDetails } from "@/models/cardPaymentDetails/cardPaymentDetails.types"

export interface ICardPaymentService {
  getCardPaymentDetails(externalId: string)
  findCardPaymentDetails(
    externalId: string,
  ): QueryResult<ICardPaymentDetails | null>
}

class CardPaymentServiceClass implements ICardPaymentService {
  getCardPaymentDetails(
    externalId: string,
  ): QueryResult<ICardPaymentDetails | null> {
    return useQuery({
      ...HasuraQueries.cardPayments.details(externalId),
      useRawResponse: true,
      placeholderData: null,
      parserFn: (data: GetCardPaymentsQuery) => {
        const cardPaymentDetails = data.card_payments[0]
        if (!cardPaymentDetails) throw new Error("Card payment not found")
        return CardPaymentDetailsParser.toDomain(cardPaymentDetails)
      },
    })
  }

  /**
   * Like getCardPaymentDetails, but resolves to null when the payment row
   * does not exist yet instead of erroring. For checkout.com Flow payments
   * (SO-30708) the row's externalId is only populated once the capture
   * webhook lands, so callers poll until this returns data.
   */
  findCardPaymentDetails(
    externalId: string,
  ): QueryResult<ICardPaymentDetails | null> {
    return useQuery({
      ...HasuraQueries.cardPayments.details(externalId),
      useRawResponse: true,
      placeholderData: null,
      parserFn: (data: GetCardPaymentsQuery) => {
        const cardPaymentDetails = data.card_payments[0]
        return cardPaymentDetails
          ? CardPaymentDetailsParser.toDomain(cardPaymentDetails)
          : null
      },
    })
  }
}

export const CardPaymentService = new CardPaymentServiceClass()
